import { ColumnDef } from '@tanstack/react-table';

import { useTableDataQuery } from '@/modules/common';
import { PaginatedTable } from '@/modules/common/components';

import { ModelSize } from '../types';

interface ModelSizesTableProps {
  onClick: (item: ModelSize) => void;
}

const columns: ColumnDef<ModelSize>[] = [
  {
    accessorKey: 'value',
    header: 'Size Name',
  },
  {
    accessorKey: 'sortOrder',
    header: 'Order',
  },
];

export function ModelSizesTable({ onClick }: ModelSizesTableProps) {
  const { data, isFetching, refetch, ...tableProps } =
    useTableDataQuery<ModelSize>({
      url: '/models/sizes',
      persistState: true,
    });

  return (
    <PaginatedTable<ModelSize>
      data={data}
      onClick={onClick}
      columns={columns}
      searchable
      searchPlaceholder="Search by size name"
      emptyDescription="No model sizes created yet"
      isLoading={isFetching}
      {...tableProps}
    />
  );
}
